import { IAnswer } from '@sdk/contracts';
import { Form, Button, FormInstance } from 'antd';
import { useTranslation } from 'react-i18next';

import { Answer } from './Answer';
import { Title, Wrapper } from './Answers.styles';

import { Icon } from '@/components/Icon';

type Props = {
  correctAnswer: number;
  handleCorrectAnswer: (value: number) => void;
  form: FormInstance;
};

export const Answers: React.FC<Props> = ({ correctAnswer, handleCorrectAnswer, form }) => {
  const { t } = useTranslation(['DefaultTranslations', 'CommonQuizFormTranslations']);
  const checkAnswers = async (_: unknown, val: IAnswer[]) => {
    if (val.length > 0 && val.every(answer => answer.text.length > 0)) {
      return Promise.resolve();
    }
    return Promise.reject(t('DefaultTranslations:REQUIRED_FIELD'));
  };

  return (
    <Wrapper>
      <Title>{t('CommonQuizFormTranslations:ANSWERS')}</Title>
      <Form.List name="answers" rules={[{ validator: checkAnswers }]}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name }) => {
              return (
                <Answer
                  key={key}
                  handleCorrectAnswer={handleCorrectAnswer}
                  name={name}
                  correctAnswer={correctAnswer}
                  remove={remove}
                  form={form}
                />
              );
            })}
            <Button type="default" onClick={() => add()} icon={<Icon i="AddAlt" />}>
              {t('CommonQuizFormTranslations:ADD_NEW_EMPTY_ANSWER')}
            </Button>
          </>
        )}
      </Form.List>
    </Wrapper>
  );
};
